import { render, staticRenderFns } from "./CSR.vue?vue&type=template&id=10d2c494&"
import script from "./CSR.vue?vue&type=script&lang=js&"
export * from "./CSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports